module.exports = __webpack_public_path__ + "static/media/routes.021c747c.pdf";